<app-template-radio [disabled]="disabled" [value]="value" [control]="control" [required]="required" [options]="options" [label]="label" />
